module.exports = __webpack_public_path__ + "img/help5_dashboard_firstrow.b6ac2bc0.png";